module.exports = __webpack_public_path__ + "media/favicon/safari-pinned-tab-876976cc.svg";